import { render, staticRenderFns } from "./PlusView.vue?vue&type=template&id=6f1aefb4&scoped=true&"
import script from "./PlusView.vue?vue&type=script&lang=js&"
export * from "./PlusView.vue?vue&type=script&lang=js&"
import style0 from "./PlusView.vue?vue&type=style&index=0&id=6f1aefb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1aefb4",
  null
  
)

export default component.exports